import { render, staticRenderFns } from "./ItemView.vue?vue&type=template&id=5dceaa45"
import script from "./ItemView.vue?vue&type=script&lang=js"
export * from "./ItemView.vue?vue&type=script&lang=js"
import style0 from "./ItemView.vue?vue&type=style&index=0&id=5dceaa45&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/appdata/www/radzs_diego/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5dceaa45')) {
      api.createRecord('5dceaa45', component.options)
    } else {
      api.reload('5dceaa45', component.options)
    }
    module.hot.accept("./ItemView.vue?vue&type=template&id=5dceaa45", function () {
      api.rerender('5dceaa45', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/frontend/components/modules/file-browser/browser/ItemView.vue"
export default component.exports